/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { GET_PRESENTATIONS } from "../graphql/getPresentations.query";
import { pretty } from "@vlinder-web/utils-react";
import { DELIVERED_REPORT } from "../graphql/getDeliveredReport.query";
import { GET_REPORT_STATUS } from "../graphql/getReportStatus.query";
import { StorageModule } from "@vlinder-web/storage-module-react";
const storageSrv = StorageModule.getInstance();

const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IDeliveredReportMethods extends IPluginMethodMap {
  getDeliveredReport(args: any): Promise<any>;
}

export class DeliveredReportService implements IAgentPlugin {
  readonly methods: IDeliveredReportMethods;
  private pollingTime = 10000;

  constructor() {
    this.methods = {
      getDeliveredReport: this.getDeliveredReport.bind(this),
    };
  }

  async getDeliveredReport(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log("args->", args);
    const band =
      storageSrv.get("currencyExchangeLocal", "local")?.bandId ?? null;
    let filters: any = {
      band: {
        eq: band,
      },
    };

    try {
      if (client) {
        // if(args?.presentation){

        //     filters = {
        //         presentation: {
        //             eq: args?.presentation
        //         }
        //     }
        //     this.pollingTime = 10000;

        // }

        if (
          args?.currDate &&
          args?.currDate !== null &&
          args?.currDate !== "" &&
          args?.endDate &&
          args?.endDate !== null &&
          args?.endDate !== ""
        ) {
          filters = {
            ...filters,
            TokenDeliveredTime: {
              gte: args?.currDate,
              lt: args?.endDate,
            },
          };
          this.pollingTime = 5000;
        }
        const costumeDataRes = await client.query({
          query: DELIVERED_REPORT,
          variables: {
            filters: filters,
          },
          fetchPolicy: "network-only",
        });

        if (
          costumeDataRes?.data?.getDeliverStatusReport?.jobId &&
          is.existy(costumeDataRes?.data?.getDeliverStatusReport?.jobId)
        ) {
          return this.checkStatus(
            costumeDataRes?.data?.getDeliverStatusReport?.jobId
          );
        } else {
          throw new Error("Some unexpected error occurred");
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
  private async checkStatus(jobId: string, retries = 25) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      const reportRes = await client.query({
        query: GET_REPORT_STATUS,
        variables: {
          jobId: jobId,
        },
        fetchPolicy: "network-only",
      });
      if (reportRes?.data?.getReportStatus?.message === "success") {
        return reportRes?.data?.getReportStatus;
      } else if (reportRes?.data?.getReportStatus?.message === "pending" || reportRes?.data?.getReportStatus?.message === "PaymentNotComplete") {
        if (retries > 0) {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              this.checkStatus(jobId, retries - 1)
                .then(resolve)
                .catch(reject);
            }, this.pollingTime || 10000);
          });
        } else {
          throw new Error("Exceeded retry limit for checking status");
        }
      } else {
        throw new Error("Some unexpected error occurred");
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
